<a #downloadLink style="display: none"></a>
<app-button
        (clickEvent)="executeDownload()"
        [color]="color"
        [disabled]="disabled"
        [fill]="fill"
        [iconName]="iconName"
        [label]="label"
        [loading]="loading"
        [size]="size"
        [withMargin]="withMargin"
        [permission]="permission"
        [entity]="entity"
        [tooltip]="tooltip"
        [withPadding]="withPadding">
</app-button>

